export default function getPrimaryClinicIdForUser(userProfile) {
    return (userProfile && userProfile.primaryClinic) ? userProfile.primaryClinic.id : undefined;
}
